/** The Seedance 2.0 definition's `model.name`. */
export const SEEDANCE_2_MODEL = 'bytedance/seedance-2.0/image-to-video';

/** The Seedance 2.0 Reference definition's `model.name`. */
export const SEEDANCE_2_REFERENCE_MODEL = 'bytedance/seedance-2.0/reference-to-video';

/** The `model` options of the Seedance 2.0 definitions, which core's Fal routing reads. */
export const SEEDANCE_2_STANDARD_VARIANT = 'Standard';
export const SEEDANCE_2_FAST_VARIANT = 'Fast';
